// extracted by mini-css-extract-plugin
module.exports = {"container":"_2gJjszxSjriR64KKLIzw_U","blogCard":"_3bIY7cZJR9lh3e9ChGduof"};